import React, { Component } from "react";
import swal from 'sweetalert';
import { toast } from "react-toastify";
import AddSharpIcon from '@material-ui/icons/AddSharp';
import SearchSharpIcon from '@material-ui/icons/SearchSharp';
import MoreVertSharpIcon from "@material-ui/icons/MoreVertSharp";
import { FormControl, Button, InputGroup, Table, Form, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';

import axios from '../../../axios';
import apiError from '../../../error';
import './iamroles.css';
import { debounce, getCookie } from "../../../function";
import Loader from "../../../component/loader/loader";

export default class IamUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roles: [],
            search: '',
            loading: false,
            limit: 10,
            activePage: 1,
            count: 0,
        }
        this.loadRoles();
        this.isTAconnected = getCookie('isTAconnected');
        this.isTASyncing = getCookie('isTASyncing');
    }

    nextPath = path => this.props.history.push(path);

    loadRoles = debounce(() => {
        this.setState({ loading: true });
        axios.get('/api/roles', {
            params: {
                search: this.state.search
            }
        })
            .then(res => {
                this.setState({ roles: res.data.roles });
                this.setState({ loading: false });
            })
            .catch(err => this.setState({ loading: false }) && apiError(err));
    }, 500)

    deleteRoles = (roleId) => {
        swal({
            title: "Do you want to delete Role?",
            icon: "warning",
            buttons: ['No', 'Yes'],
        })
            .then(willSuccess => {
                if (willSuccess) {
                    this.setState({ loading: true });
                    axios.delete('/api/roles/' + roleId, {})
                        .then(res => {
                            this.loadRoles();
                            this.setState({ search: "" });
                            this.setState({ loading: false });
                            toast.success("Role Deleted Successfully");
                        })
                        .catch(err => this.setState({ loading: false }) && apiError(err));
                }
            });
    }

    render() {
        return (
            <div className="content-wrap">
                <div className="breadcrumbbar">
                    <div className="flexRow row">
                        <div className="col-md-4">
                            <div className="page-head d-flex align-items-center justify-content-between">
                                <h4 className="page-title">Roles</h4>
                            </div>
                        </div>
                        {!this.isTAconnected &&
                            <div className="col-md-8 flexFilterButtons">
                                <div className="btn-container float-right d-flex align-items-center">
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            this.isTASyncing ? (
                                                <Tooltip id="top">Threatcop Admin Sync is already in progress</Tooltip>
                                            ) : (
                                                <Tooltip id="top" className="d-none" />
                                            )
                                        }
                                    >
                                        <Button className={`btn-primary ${this.isTASyncing ? "disabledCls2" : ''}`} onClick={e => { if (!this.isTASyncing) return this.nextPath('/iam/roles/0') }}><AddSharpIcon className="btn-icon"></AddSharpIcon>Create Roles</Button>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        }
                    </div>
                </div>

                <div className="contentbar">
                    <div className="filter-without-border">
                        <div className="align-items-center row">
                            <div className="col-md-3">
                                <div className="positionSearchIcon">
                                    <InputGroup className="search-wrap">
                                        <FormControl type="text" placeholder="Search" value={this.state.search} onChange={e => this.setState({ search: e.target.value }, () => this.loadRoles())} className="inputSearch mr-sm-2 form-control" /><SearchSharpIcon className="search-icon"></SearchSharpIcon>
                                    </InputGroup>
                                </div>
                            </div>

                            <div className="col-md-9">
                                <div className="rightFilters">
                                    <Dropdown className="d-inline-block">
                                        <Dropdown.Toggle variant="secondary" id="limit-dropdown" className="dropdown-color-white">
                                            {this.state.limit}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {[10, 25, 50, 100].map((limit) => (
                                                <Dropdown.Item
                                                    key={`limit-${limit}`}
                                                    onClick={() => this.setState({ limit: limit, activePage: 1 }, () => this.loadRoles())}
                                                    active={this.state.limit === limit}
                                                >
                                                    {limit}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tableContainerWrapInner">
                        <Table>
                            <thead className="bg-light">
                                <tr>
                                    <th>ID</th>
                                    <th>Role Name</th>
                                    <th>Type</th>
                                    <th>Description</th>
                                    {!this.isTAconnected && <th>Action</th>}

                                </tr>
                            </thead>
                            <tbody>
                                {this.state.roles.map((role, index) => {
                                    return <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td style={{ cursor: 'pointer' }} onClick={e => this.nextPath('/iam/roles/' + role.id)}>{role.name}</td>
                                        <td>{role.type}</td>
                                        <td>{role.description}</td>
                                        {!this.isTAconnected &&
                                            <td>
                                                <Dropdown
                                                    className="action-dropdown dropdownIcon" ref={this.selectRef}>
                                                    <Dropdown.Toggle className="btn-only" id="dropdown-basic">
                                                        <MoreVertSharpIcon className="dot-icon"></MoreVertSharpIcon>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={e => this.nextPath('/iam/roles/' + role.id)}>{(role.type === "Managed" || this.isTAconnected) ? "View" : "Edit"}</Dropdown.Item>
                                                        {role.type !== "Managed" && !this.isTAconnected &&
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    this.isTASyncing ? (
                                                                        <Tooltip id="top"> <span>Threatcop Admin Sync is already in progress</span>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <Tooltip id="top" className="d-none" />
                                                                    )
                                                                }
                                                            >
                                                                <Dropdown.Item className={`${this.isTASyncing && 'disabledCls3'}`} onClick={e => { if (!this.isTASyncing) return this.deleteRoles(role.id) }}>Delete</Dropdown.Item>
                                                            </OverlayTrigger>
                                                        }
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        }
                                    </tr>
                                })}
                            </tbody>
                        </Table>
                    </div>
                </div>
                {this.state.loading ? <Loader></Loader> : null}
            </div>
        );
    }
}